import React, { useEffect } from 'react';
import './psbiendisc.css';
import { psbiendisc } from '../../json/psbiendisc';

const Psbiendisc = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className='container container-mh'>
      <div className='row'>
        <div className='col-12'>
          <h3 className='title'>Programa Bienestar de Personas con Discapacidad</h3>
          <hr className='hr-gob' />
        </div>
      </div>
      
      <div className='row'>
        <div className='col-12 container-armon'>
          <div className='armo-collapse'>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
             
              <div style={{ textAlign: 'left' }}>
                <h5 style={{ fontWeight: 'bold' }}>Descripción del Programa</h5>
                <p>
              
                </p>
                <h6 className='description' style={{ marginTop: '20px' }}>
                El programa fue creado con la finalidad de coadyuvar a mejorar el ingreso monetario de las personas con discapacidad total y permanente de 0 hasta 1 día antes de cumplir los 65 años de edad, que habite en localidades de alta y muy alta marginación, en situación de pobreza, así como a población indígena de las zonas de atención prioritaria de la entidad, contribuyendo de esta manera a la disminución de las barreras arquitectónicas, físicas, económicas, sociales, y coadyuvando al desarrollo personal y bienestar social de este sector de la población, a través de apoyo económico.
                </h6><br />
                <h5 style={{ fontWeight: 'bold' }}>Objetivo del Programa</h5>
                <p>
                Contribuir a la mejora del ingreso monetario de niñas, niños, adolescentes, jóvenes y adultos con discapacidad total y permanente, de 0 años y hasta un día antes de cumplir los 65 años de edad, que habiten en las 12 regiones del Estado de Hidalgo, de acuerdo al Plan Estatal de Desarrollo 2022-2028, dando prioridad a las localidades de alta y muy alta marginación, en pobreza o en los 22 municipios de atención prioritaria indígena del Estado de Hidalgo.
                </p>
                <h5 style={{ fontWeight: 'bold' }}>Población Objetivo</h5>
                <p>
                Personas que tengan desde 0 años hasta un día antes de cumplir los 65 años de edad, con discapacidad total y permanente.
                </p>
                <h5 style={{ fontWeight: 'bold' }}>Cobertura</h5>
                <p>
                El programa “Bienestar de las Personas con Discapacidad” priorizará la distribución equitativa de los apoyos en las 12 regiones del Estado de Hidalgo, de acuerdo al Plan Estatal de Desarrollo 2022- 2028, dando prioridad a las localidades de alta y muy alta marginación, localidades de pobreza o de los 22 municipios atención prioritaria indígena del Estado de Hidalgo.
                </p>
                <h5 style={{ fontWeight: 'bold' }}>Vigencia</h5>
                <p>
                Anual
                </p>
                <h5 style={{ fontWeight: 'bold' }}>Áreas de atención</h5>
                <p>
                  
                  <ul>
                  <li>Secretaría de Bienestar en Inclusión Social<br />                    
                  </li>
                  <li>Subsecretaría de Inclusión y Desarrollo<br />
                  </li>
                  </ul></p>
                <h5 style={{ fontWeight: 'bold' }}>Personas Responsables del Programa</h5>
                <p>
                  
                  <ul>
                  <li>Ing. Julián Nochebuena Hernández<br />                    
                  </li>
                  <li>Lic. Francisco Alberto Rico Romo<br />
                  </li>
                  <li>Ing. Juan Roberto Lazcano Trejo<br />
                  </li>
                  <li>Lic. Rosa Isela Ramírez Romero<br />
                  </li>
                  </ul></p>
                <h5 style={{ fontWeight: 'bold' }}>Teléfono de Contacto</h5>
                <p>
                (771) 717 8000 Ext. 8948, 8950, 8933, 8538
                </p>
                <h5 style={{ fontWeight: 'bold' }}><strong><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2023/ROPS_Disc_2023.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Reglas de Operación</a></strong></h5>
                <p>
                </p>
                <h5 style={{ fontWeight: 'bold' }}><strong><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/conv/2023//Conv_Disc_2023.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Convocatoria</a></strong></h5>
                <p>
                </p>
              </div>
            </div>
            
          </div>
        </div>
      </div>    
    </div>
  );
};

export default Psbiendisc;